module.exports = __webpack_public_path__ + "static/media/Grupo Disco.964edef9.jpg";